import store from './store';


export default {

  beforeRouteEnter: function (to, from, next) {

    let token = store.getPersonToken();

    if (!token) {
      next({path: '/login'});
    } else {
      next();
    }

  }
};
